export interface VideoFramePulse {
  start: () => void;
  stop: () => void;
}

export interface VideoFrameTickPayload {
  mediaTime: number;
}

export const createVideoFramePulse = (
  video: HTMLVideoElement,
  onTick: (payload: VideoFrameTickPayload) => void
): VideoFramePulse => {
  let rvfcId: number | null = null;
  let rafId: number | null = null;

  const stop = () => {
    const anyVideo = video as any;
    if (rvfcId != null && typeof anyVideo.cancelVideoFrameCallback === "function") {
      anyVideo.cancelVideoFrameCallback(rvfcId);
    }
    if (rafId != null) {
      cancelAnimationFrame(rafId);
    }
    rvfcId = null;
    rafId = null;
  };

  const start = () => {
    stop();
    const anyVideo = video as any;
    if (typeof anyVideo.requestVideoFrameCallback === "function") {
      const loop = (_now: number, metadata?: { mediaTime?: number }) => {
        if (video.paused || video.ended) {
          rvfcId = null;
          return;
        }
        const mediaTime =
          typeof metadata?.mediaTime === "number" && Number.isFinite(metadata.mediaTime)
            ? metadata.mediaTime
            : video.currentTime || 0;
        onTick({ mediaTime });
        rvfcId = anyVideo.requestVideoFrameCallback(loop);
      };
      rvfcId = anyVideo.requestVideoFrameCallback(loop);
      return;
    }

    const loop = () => {
      if (video.paused || video.ended) {
        rafId = null;
        return;
      }
      onTick({ mediaTime: video.currentTime || 0 });
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
  };

  return { start, stop };
};
